import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Stats from "@/components/Stats";
import Services from "@/components/Services";
import Destinations from "@/components/Destinations";
import Process from "@/components/Process";
import Testimonials from "@/components/Testimonials";
import Booking from "@/components/Booking";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function Landing() {
  const location = useLocation();
  useEffect(() => {
    document.title = "Edubridge — Study Abroad Consultancy";
    const timer = setTimeout(() => {
      const el = location.hash && document.getElementById(location.hash.slice(1));
      if (el) window.__lenis?.scrollTo(el, { offset: -88, immediate: true });
      else window.scrollTo(0, 0);
    }, 150);
    return () => clearTimeout(timer);
  }, [location.hash, location.key]);
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="grain relative min-h-screen bg-ink font-sans text-frost">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Stats />
        <Services />
        <Destinations />
        <Process />
        <Testimonials />
        <Booking />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
